export default "__VITE_ASSET__e7213389__"